import React, { ReactNode } from 'react';
import { makeStyles, createStyles, Box } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import { FormikProps } from 'formik';
import { TextFieldProps } from '@material-ui/core/TextField/TextField';
import cn from 'classnames';

import { RadioButtonUnchecked as RadioButtonUncheckedIcon, RadioButtonChecked as RadioButtonCheckedIcon } from '@material-ui/icons/';
import { TranquiTheme } from '../../containers/App/theme';

export type IFormikCheckProps = TextFieldProps & {
  label?: string,
  labelCheck?: ReactNode,
  valueId: string,
  formik: FormikProps<any>;
  className?: string;
  color?: 'primary' | 'secondary';
  'data-test'?: string;
  iconClassName?: string;
  helperTextClassName?: string;
  alignTop?: boolean;
};

const FormikCheck: React.FC<IFormikCheckProps> = (props) => {
  const {
    label = '',
    labelCheck,
    valueId,
    className,
    alignTop,
    color = 'primary',
    iconClassName,
    helperTextClassName,
    formik: {
      values, errors, handleChange,
      touched, handleBlur,
    },
    ...other
  } = props;

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const error = !!errors[valueId] && !!touched[valueId];
  const isChecked = values[valueId];
  if (typeof isChecked !== 'boolean') return null;

  return (
    <Box display="flex" className={className}>
      <FormControl
        // required
        error={error}
        component="fieldset"
      // {...other}
      >
        <FormLabel component="legend">
          {' '}
          {label}
          {' '}
        </FormLabel>
        <FormGroup>
          <FormControlLabel
            className={cn(alignTop && classes.alignTop)}
            control={(
              <Checkbox
                name={valueId}
                checked={isChecked}
                onChange={handleChange}
                onBlur={handleBlur}
                color={color}
                className={classes.customCheck}
                checkedIcon={<RadioButtonCheckedIcon className={iconClassName} />}
                icon={<RadioButtonUncheckedIcon className={iconClassName} />}
                data-testid="formik-check__checkbox"
              />
            )}
            label={labelCheck}
          />
        </FormGroup>
        <FormHelperText className={cn(error && helperTextClassName)}>
          {error ? errors[valueId] : other.helperText}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  customCheck: {},
  alignTop: {
    alignItems: 'flex-start',
  },
}));

export default FormikCheck;
